import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import AppBar from '../../commons/AppBar'
import FromServer from './FromServer';
import BugeteList from '../../commons/BugeteList'
import { Fab } from '@material-ui/core';

export default class  extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
            listBugete:[],
            listCosturi:[],
            isOpenInsertBugete:false,
            isOpenInsertCosturi:false,
            }
    }

     componentDidMount(){

        this.getData();
    }

    getData = async()=>{

        let fs = new FromServer();

        let getData = await fs.getData();

        // console.log('getData :', getData);

        this.setState({listBugete:getData.bugete,
                        listCosturi:getData.costuri})
    }

     render() { 
       return (
          <div>
                <AppBar
                    history={this.props.history}
                    title={this.dictionary.appBar.drawer.nomenclatoare}
                    />

                 <div className='container'>
                 <Fab  onClick={()=>{this.setState({isOpenInsertBugete:true})}} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text'>add</i>
                            </Fab>
                <BugeteList
                    elemente={this.state.listBugete}
                    dict={this.dictionary}
                    onlyColumns={{nume:'nume', proiecte:'proiecte', contabilitate:'contabilitate', intern:'intern'} }
                    handleProiecte={this.changeProiecte}
                    handleContabilitate={this.changeContabilitate}
                    handleIntern={this.changeIntern}
                    />
                </div>


         </div>
        );
       }
}